module.exports = __webpack_public_path__ + "img/41.153ea1e4.png";